"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContent = exports.FieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const ColorContent_1 = require("./ColorContent");
const DateContent_1 = require("./DateContent");
const NumberContent_1 = require("./NumberContent");
const RangeContent_1 = require("./RangeContent");
const SelectContent_1 = require("./SelectContent");
const TextContent_1 = require("./TextContent");
const TimestampContent_1 = require("./TimestampContent");
exports.FieldType = t.keyof({
    Text: null,
    Date: null,
    Timestamp: null,
    Color: null,
    Number: null,
    Range: null,
    Select: null,
});
exports.FieldContent = t.union([
    DateContent_1.DateContent,
    ColorContent_1.ColorContent,
    NumberContent_1.NumberContent,
    RangeContent_1.RangeContent,
    SelectContent_1.SelectContent,
    TextContent_1.TextContent,
    TimestampContent_1.TimestampContent,
]);
(0, tslib_1.__exportStar)(require("./ColorContent"), exports);
(0, tslib_1.__exportStar)(require("./common"), exports);
(0, tslib_1.__exportStar)(require("./DateContent"), exports);
(0, tslib_1.__exportStar)(require("./NumberContent"), exports);
(0, tslib_1.__exportStar)(require("./RangeContent"), exports);
(0, tslib_1.__exportStar)(require("./SelectContent"), exports);
(0, tslib_1.__exportStar)(require("./TextContent"), exports);
(0, tslib_1.__exportStar)(require("./TimestampContent"), exports);
